<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="活动ID" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activityTitle">
              <el-input
                v-model="searchForm.activityTitle"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="区域" prop="orgName">
              <el-input
                v-model="searchForm.orgName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店" prop="shopName	">
              <el-input
                v-model="searchForm.shopName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="职员" prop="staffName">
              <el-input
                v-model="searchForm.staffName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
               <q-date-picker 
                startFiled="createdTimeStart" 
                endFiled="createdTimeEnd" 
                v-model="searchForm" ref="dateRef"
                :isClearable="false"
              />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportFile">
            导出
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="activityId" label="活动ID" min-width="80" align="center"></el-table-column>
          <el-table-column prop="activityTitle" label="活动名称"  align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createdTime" label="创建时间" width="160" align="center"></el-table-column>
          <el-table-column prop="createdBy" label="创建人" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="orgName" label="区域" align="center" width="150"></el-table-column>
          <el-table-column prop="customerName" label="经销商" width="100" align="center"></el-table-column>
          <el-table-column prop="customerCode" label="经销商编码" width="100" align="center"></el-table-column>
          <el-table-column prop="businessStatus" label="经销商经营状态" align="center" width="120"></el-table-column>
          <el-table-column prop="shopName" label="门店" align="center" width="140"></el-table-column>
          <el-table-column prop="staffCode" label="职员编码" align="center" width="120"></el-table-column>
          <el-table-column prop="staffName" label="职员" align="center" width="120"></el-table-column>
          <el-table-column prop="authenticationString" label="是否认证" align="center" width="80"></el-table-column>
          <el-table-column prop="isDelete" label="是否离职" align="center" width="80"></el-table-column>
          <el-table-column prop="joinTime" label="参与时间" align="center" width="155"></el-table-column>
          <el-table-column prop="browseCount" label="浏览次数" align="center" width="80"></el-table-column>
          <el-table-column prop="browseUserCount" label="拉新人数" align="center" width="80"></el-table-column>
          <el-table-column prop="signUpCount" label="报名数" align="center" width="80"></el-table-column>
          <el-table-column prop="refundCount" label="退款数" align="center" width="80"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import moment from "moment"
export default {
  name: "lashinDetail",
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: false,
      searchForm: {
        activityId: "",
        activityTitle: "",
        orgName: "",
        customerName: "",
        shopName: "",
        staffName: "",
        createdTimeStart: "",
        createdTimeEnd: "",
      },
    
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryActivityStaffAnalyzeData(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.createdTimeStart = ''
      this.searchForm.createdTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    exportFile() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryActivityStaffAnalyzeData", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  filters: {},
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>
